module.exports = __webpack_public_path__ + "static/word-SPECIAL-OFFER.31bd31ee.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/festival/word-SPECIAL-OFFER.png
// module id = 278
// module chunks = 2